import * as z from "zod/v4";

export const sendTestPoEmail = {
  name: "sendTestPoEmail" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean(), message: z.string() }),
};
